import { GrtAiMarkdown } from '@/components/Markdown/GrtAiMarkdown';
import s from './style.module.scss';
const RecommendReasoning = (props) => {
    const { personalized_recommend_reasoning } = props;

    return (
        <>
            <div className={s['recommend-reasoning-wrap']}>
                <GrtAiMarkdown className="ai-markdown-box" content={personalized_recommend_reasoning}></GrtAiMarkdown>
            </div>
        </>
    );
};
export default RecommendReasoning;
